const initialStateAccessLevelPosition = {
    access_level_position: [],
    access_level_position_updated: false,
};

export default initialStateAccessLevelPosition;